import { put, call, takeLatest } from 'redux-saga/effects'
import { ACTION_TYPES } from 'store/reducers/financialPosition'
import { ACTION_TYPES as ACTION_TYPES_NOTIFICATION } from 'store/reducers/notification'
import { getFinancialPosition as getFinancialPositionService } from 'services'
import { CUSTODY_MESSAGES } from 'config/messages'

const {
  FINANCIAL_POSITION_REQUEST,
  FINANCIAL_POSITION_SUCCESS,
  FINANCIAL_POSITION_ERROR
} = ACTION_TYPES
const { SHOW_NOTIFICATION } = ACTION_TYPES_NOTIFICATION

export function *getFinancialPosition(payload) {
  try {
    const response = yield call(getFinancialPositionService, payload)
    yield put({ type: FINANCIAL_POSITION_SUCCESS, payload: response.data })
  } catch (err) {
    yield put({ type: FINANCIAL_POSITION_ERROR, payload: err })
    const { hasOwnProperty } = Object
    yield put({
      type: SHOW_NOTIFICATION,
      payload: {
        text:
          hasOwnProperty.call(err, 'messages') && err.messages.length
            ? err.messages[0]
            : CUSTODY_MESSAGES.DEFAULT_ERROR,
        type: 'error'
      }
    })
  }
}

export default function *watchFinancialPosition() {
  yield takeLatest(FINANCIAL_POSITION_REQUEST, getFinancialPosition)
}
